import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { refreshFileSession } from './lib/fileSession';

const root = ReactDOM.createRoot(document.getElementById('root'));
refreshFileSession().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
